import {cs} from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {GlobalEvent} from "@Common/react/global-event";
import {Static2} from "@Common/react/static-2";
import {Rerender} from "@Common/react/rerender";

export const Responsive2 = ({translate, next}) => cs(
    ["current", (_, next) => Static2({
        // getInitValue: () =>
        next,
    })],
    ["rerender", (_, next) => Rerender({next})],
    ({current, rerender}) => {
        const translated = translate(window.innerWidth);
        if (current.get() !== translated) {
            current.set(translated);
        }
        return fragments(
            GlobalEvent({
                eventName: "resize",
                action: () => {
                    const newTranslated = translate(window.innerWidth);

                    if (current.get() !== newTranslated) {
                        rerender.invoke();
                    }
                },
            }),
            next(translated),
        );
    },
);